<div *ngIf="vars.social" (click)="shareClickListner($event)" [ngClass]="{'active': showBtns}" class="floating-share">
  <div *ngIf="telegram" class="fab telegram" [ngClass]="{'no': noClass, 'active': showBtns}">
    <app-telegram-share [isFundraiserEnded]="isFundraiserEnded"></app-telegram-share>
  </div>
  <div class="fab whatsapp" [ngClass]="{'no': noClass, 'active': showBtns}">
    <app-whatsapp-share buttonType="round" [fundraiser]="fundraiser" [basicInfo]="basicInfo"
                        [isFundraiserEnded]="isFundraiserEnded" position="PosOS1" [dream11]="dream11">
    </app-whatsapp-share>
  </div>
  <div class="fab facebook" [ngClass]="{'no': noClass, 'active': showBtns}">
    <app-fb-share buttonType="round" [fundraiser]="fundraiser" position="PosOS1">
    </app-fb-share>
  </div>
</div>

<div (click)="shareClickListner($event)"
  [ngClass]="{'active': showBtns,
              'v5': isMobile && !userData?.aggdonationall?.funds && vars.pageName === 'stories'}"
              class="floating-share">
  <div class="fab" [ngClass]="{'no': noClass, 'active': showBtns, 'v5': isMobile && !userData?.aggdonationall?.funds && vars.pageName === 'stories'}" *ngFor="let btn of shareButtons">
    <button [ngStyle]="{'background-color': btn.color}" (click)="share(btn)" mat-icon-button>
      <mat-icon [ngClass]="btn.icon"></mat-icon>
    </button>
  </div>
</div>